import React, { useContext, useState } from "react";
import Error from "../../components/Error";
import Loading from "../../components/Loading";
import { AuthContext } from "../../context/auth/AuthContext";
import { Request } from "../../api/plant/Plant.api";
import Success from "../../components/Success";

const EditPlantContainer = ({ plant, children }) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const { token } = useContext(AuthContext);
  const [success, setSuccess] = useState(false);

  const onSubmit = (values, actions) => {
    setError(null);
    setLoading(true);
    Request.updatePlant(token.access, { ...values, plant: plant.id })
      .then((data) => onSuccess(data, actions))
      .catch((error) => onFailure(error, actions));
  };

  const onSuccess = ({ data }, actions) => {
    actions.setSubmitting(false);
    setLoading(false);
    setSuccess(true);
  };

  const onFailure = (error, actions) => {
    setError(error);
    setLoading(false);
    actions.setSubmitting(false);
  };

  const onCloseSuccesPopup = () => {
    setSuccess(null);
  };

  return (
    <>
      {error ? <Error message={error} onClose={() => setError(null)} /> : null}
      {loading ? <Loading /> : null}
      {success ? (
        <Success
          message="Plant data has been updated."
          onClose={() => onCloseSuccesPopup()}
        />
      ) : null}
      {children({ onSubmit, plant })}
    </>
  );
};

export default EditPlantContainer;
